import { render, staticRenderFns } from "./GEditImage.vue?vue&type=template&id=6e329ff6&"
import script from "./GEditImage.vue?vue&type=script&lang=js&"
export * from "./GEditImage.vue?vue&type=script&lang=js&"
import style0 from "./GEditImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e329ff6')) {
      api.createRecord('6e329ff6', component.options)
    } else {
      api.reload('6e329ff6', component.options)
    }
    module.hot.accept("./GEditImage.vue?vue&type=template&id=6e329ff6&", function () {
      api.rerender('6e329ff6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/GEditImage.vue"
export default component.exports